import { render, staticRenderFns } from "./QueryDetailList.vue?vue&type=template&id=d4ef3184&scoped=true&"
import script from "./QueryDetailList.vue?vue&type=script&lang=ts&"
export * from "./QueryDetailList.vue?vue&type=script&lang=ts&"
import style0 from "./QueryDetailList.vue?vue&type=style&index=0&id=d4ef3184&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ef3184",
  null
  
)

export default component.exports